// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"RRrmZWt-74ekYYqH6iFNx","container":"_1TSBk1SQdoWfllijP6MlJZ","singleItem":"NLJlUFH6JYo7kWanukuO8","item":"_1tcCsbHl40bJECDQCYoCh0","video":"_3ck_m6JDNbbz0I9LCgMXod","videoLink":"ga3CS9n18qq3RMUNobbJ9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/InlineGallery/InlineGallery.scss
// module id = 1727
// module chunks = 0